import {jQuery as $, lodash as _} from 'lib/shim';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from 'defines';




const SELECTOR = '.organism-image-fullwidth-textbox';



class OrganismImageFullwidthTextbox {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$contentHolder = this._$element.find('.content-holder').first();
			this._$placeholder = this._$element.find('.placeholder').first();
			this._$image = this._$element.find('.atom-image').first();

			this._prime();
		}

		return $element;
	}



	_prime() {
		this._setContentHolderPosition();

		this._app.registerResizeCallback('image-fullwidth-textbox-'+this._id, () => {
			this._setContentHolderPosition();
		});
	}



	_setContentHolderPosition() {
		let contentHeight = this._$contentHolder.outerHeight(),
			imageHeight = this._$image.outerHeight(),
			vpWidth = window.innerWidth || $(window).width();

		if (vpWidth < BREAKPOINT_TABLET) {
			// minus 50 pixel, because this is the value, which is used to overlay the image
			this._$placeholder.height(contentHeight - 50);
			this._$contentHolder.css('top', imageHeight -50);
		} else {
			this._$contentHolder.css('top', 'auto');
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismImageFullwidthTextbox(app, $this));
	});

	return $elements;
}